
const mapPopulationPrograms = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // Section 1 - Population of Focus
    flat['pof_homeless'] = cyEcm.populationOfFocus?.homeless || false;
    flat['pof_ed'] = cyEcm.populationOfFocus?.atRiskED || false;
    flat['pof_smi'] = cyEcm.populationOfFocus?.smiSud || false;
    flat['pof_youth'] = cyEcm.populationOfFocus?.youthCorrectional || false;
    flat['pof_ccs'] = cyEcm.populationOfFocus?.ccsCcsWcm || false;
    flat['pof_welfare'] = cyEcm.populationOfFocus?.childWelfare || false;
    flat['pof_idd'] = cyEcm.populationOfFocus?.idd || false;
    flat['pof_pregnant'] = cyEcm.populationOfFocus?.pregnantPostpartum || false;

    // Programs
    flat['prog_smhs'] = cyEcm.programs?.smhs || false;
    flat['prog_dmc'] = cyEcm.programs?.dmc || false;
    flat['prog_dmc_ods'] = cyEcm.programs?.dmcOds || false;
    flat['prog_juvenile'] = cyEcm.programs?.juvenileJustice || false;
    flat['prog_ccs'] = cyEcm.programs?.ccs || false;
    flat['prog_ccs_wcm'] = cyEcm.programs?.ccsWcm || false;
    flat['prog_child_welfare'] = cyEcm.programs?.childWelfare || false;
    flat['prog_regional'] = cyEcm.programs?.regionalCenter || false;
    flat['prog_local'] = cyEcm.programs?.localProgram || false;
    flat['prog_local_list'] = cyEcm.programs?.localProgramList || '';
    flat['prog_other'] = cyEcm.programs?.other || false;
    flat['prog_other_list'] = cyEcm.programs?.otherList || '';
    flat['prog_na'] = cyEcm.programs?.na || false;
    return flat;
};

const mapConsentDemographics = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // Consent
    flat['consent_date'] = cyEcm.consent?.date || '';
    flat['consent_verbal'] = cyEcm.consent?.verbal || false;
    flat['consent_written'] = cyEcm.consent?.written || false;
    flat['consent_cy'] = cyEcm.consent?.cyMember || false;
    flat['consent_parent'] = cyEcm.consent?.parentGuardian || false;
    flat['consent_dcfs'] = cyEcm.consent?.dcfs || false;
    flat['consent_court'] = cyEcm.consent?.court || false;
    flat['consent_foster'] = cyEcm.consent?.fosterParent || false;

    // Family ECM
    flat['family_yes'] = cyEcm.familyEcm?.yes || false;
    flat['family_no'] = cyEcm.familyEcm?.no || false;
    flat['family_members'] = cyEcm.familyEcm?.membersList || '';

    // Demographics
    flat['contact_cy'] = cyEcm.demographics?.primaryContact?.cyMember || false;
    flat['contact_parent'] = cyEcm.demographics?.primaryContact?.parentGuardian || false;
    flat['contact_other'] = cyEcm.demographics?.primaryContact?.other || false;
    flat['contact_other_list'] = cyEcm.demographics?.primaryContact?.otherList || '';
    flat['speaking_cy'] = cyEcm.demographics?.speakingWith?.cyMember || false;
    flat['speaking_parent'] = cyEcm.demographics?.speakingWith?.parentGuardian || false;
    flat['speaking_other'] = cyEcm.demographics?.speakingWith?.other || false;
    flat['speaking_other_list'] = cyEcm.demographics?.speakingWith?.otherList || '';
    flat['today_date'] = cyEcm.demographics?.todayDate || '';
    flat['cy_member_name'] = cyEcm.demographics?.cyMemberName || '';
    flat['dob'] = cyEcm.demographics?.dateOfBirth || '';
    flat['medi_cal_id'] = cyEcm.demographics?.mediCalId || '';
    flat['preferred_name'] = cyEcm.demographics?.preferredName || '';
    flat['gender_identification'] = cyEcm.demographics?.genderIdentification || '';
    flat['language_cy'] = cyEcm.demographics?.languageCy || '';
    flat['language_parent'] = cyEcm.demographics?.languageParent || '';
    flat['interpreter_yes'] = cyEcm.demographics?.interpreterNeeded?.yes || false;
    flat['interpreter_no'] = cyEcm.demographics?.interpreterNeeded?.no || false;
    flat['interpreter_language'] = cyEcm.demographics?.interpreterNeeded?.language || '';

    // Cultural beliefs
    flat['cultural_yes'] = cyEcm.demographics?.culturalBeliefs?.yes || false;
    flat['cultural_no'] = cyEcm.demographics?.culturalBeliefs?.no || false;
    flat['cultural_declined'] = cyEcm.demographics?.culturalBeliefs?.declined || false;
    flat['cultural_describe'] = cyEcm.demographics?.culturalBeliefs?.describe || '';

    // Parent info
    flat['parent_name'] = cyEcm.demographics?.parentName || '';
    flat['parent_contact'] = cyEcm.demographics?.parentContact || '';

    // Employment & Needs
    flat['employment_part_time'] = cyEcm.demographics?.employment?.partTime || false;
    flat['employment_full_time'] = cyEcm.demographics?.employment?.fullTime || false;
    flat['employment_day_laborer'] = cyEcm.demographics?.employment?.dayLaborer || false;
    // Template ID aliases
    flat['job_part_time'] = cyEcm.demographics?.employment?.partTime || false;
    flat['job_full_time'] = cyEcm.demographics?.employment?.fullTime || false;
    flat['job_day_laborer'] = cyEcm.demographics?.employment?.dayLaborer || false;
    flat['most_important_need'] = cyEcm.demographics?.mostImportantNeed || '';

    // Contact info
    flat['contact_preferred_mail'] = cyEcm.contactInfo?.preferredMail || '';
    flat['contact_home_phone'] = cyEcm.contactInfo?.homePhone || '';
    flat['contact_cell_phone'] = cyEcm.contactInfo?.cellPhone || '';
    // Template ID aliases
    flat['preferred_mail'] = cyEcm.contactInfo?.preferredMail || '';
    flat['home_phone'] = cyEcm.contactInfo?.homePhone || '';
    flat['cell_phone'] = cyEcm.contactInfo?.cellPhone || '';
    flat['email_address'] = cyEcm.contactInfo?.email || '';
    flat['contact_in_person'] = cyEcm.contactInfo?.preferredContact?.inPerson || false;
    flat['contact_phone'] = cyEcm.contactInfo?.preferredContact?.phone || false;
    flat['contact_email'] = cyEcm.contactInfo?.preferredContact?.email || false;
    flat['contact_text'] = cyEcm.contactInfo?.preferredContact?.text || false;

    // Additional demographic aliases used in template
    flat['emergency_contact_info'] = cyEcm.emergencyContact?.phone || cyEcm.emergencyContact?.address || '';
    flat['education_yes'] = cyEcm.healthLiteracy?.understandHealthInfo?.confidently || cyEcm.healthLiteracy?.understandHealthInfo?.somewhat || false;
    flat['education_no'] = cyEcm.healthLiteracy?.understandHealthInfo?.notAtAll || false;
    flat['education_na'] = false;
    flat['education_declined'] = cyEcm.healthLiteracy?.understandHealthInfo?.declined || false;
    flat['doctor_help_yes'] = cyEcm.healthLiteracy?.helpWithForms?.yes || false;
    flat['doctor_help_no'] = cyEcm.healthLiteracy?.helpWithForms?.no || false;
    flat['doctor_help_na'] = cyEcm.healthLiteracy?.helpWithForms?.na || false;
    flat['doctor_help_declined'] = cyEcm.healthLiteracy?.helpWithForms?.declined || false;
    flat['forms_help_yes'] = cyEcm.healthLiteracy?.fillOutForms?.confidently || false;
    flat['forms_help_no'] = cyEcm.healthLiteracy?.fillOutForms?.notAtAll || false;
    flat['forms_help_na'] = false;
    flat['forms_help_declined'] = cyEcm.healthLiteracy?.fillOutForms?.declined || false;

    return flat;
};

const mapAssessments = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    const tools = cyEcm.assessmentTools || cyEcm.assessments || {};
    // Section 1 table
    flat['assess_aces'] = tools.aces?.used || tools.acesOrPearls?.used || false;
    flat['assess_aces_yes'] = tools.aces?.yes || tools.acesOrPearls?.yes || false;
    flat['assess_aces_date'] = tools.aces?.date || tools.acesOrPearls?.date || '';
    flat['assess_aces_no'] = tools.aces?.no || tools.acesOrPearls?.no || false;
    flat['assess_aces_na'] = tools.aces?.na || tools.acesOrPearls?.na || false;

    flat['assess_cans'] = tools.cans?.used || false;
    flat['assess_cans_yes'] = tools.cans?.yes || false;
    flat['assess_cans_date'] = tools.cans?.date || '';
    flat['assess_cans_no'] = tools.cans?.no || false;
    flat['assess_cans_na'] = tools.cans?.na || false;

    flat['assess_psc'] = tools.psc?.used || tools.psc35?.used || false;
    flat['assess_psc_yes'] = tools.psc?.yes || tools.psc35?.yes || false;
    flat['assess_psc_date'] = tools.psc?.date || tools.psc35?.date || '';
    flat['assess_psc_no'] = tools.psc?.no || tools.psc35?.no || false;
    flat['assess_psc_na'] = tools.psc?.na || tools.psc35?.na || false;

    flat['assess_needs'] = tools.needs?.used || tools.needsEvaluation?.used || false;
    flat['assess_needs_yes'] = tools.needs?.yes || tools.needsEvaluation?.yes || false;
    flat['assess_needs_date'] = tools.needs?.date || tools.needsEvaluation?.date || '';
    flat['assess_needs_no'] = tools.needs?.no || tools.needsEvaluation?.no || false;
    flat['assess_needs_na'] = tools.needs?.na || tools.needsEvaluation?.na || false;

    flat['assess_youth'] = tools.youth?.used || tools.youthScreening?.used || false;
    flat['assess_youth_yes'] = tools.youth?.yes || tools.youthScreening?.yes || false;
    flat['assess_youth_date'] = tools.youth?.date || tools.youthScreening?.date || '';
    flat['assess_youth_no'] = tools.youth?.no || tools.youthScreening?.no || false;
    flat['assess_youth_na'] = tools.youth?.na || tools.youthScreening?.na || false;

    flat['assess_dph'] = tools.dph?.used || tools.dphFosterCare?.used || false;
    flat['assess_dph_yes'] = tools.dph?.yes || tools.dphFosterCare?.yes || false;
    flat['assess_dph_date'] = tools.dph?.date || tools.dphFosterCare?.date || '';
    flat['assess_dph_no'] = tools.dph?.no || tools.dphFosterCare?.no || false;
    flat['assess_dph_na'] = tools.dph?.na || tools.dphFosterCare?.na || false;

    flat['assess_protective'] = tools.protective?.used || tools.protectiveFactors?.used || false;
    flat['assess_protective_yes'] = tools.protective?.yes || tools.protectiveFactors?.yes || false;
    flat['assess_protective_date'] = tools.protective?.date || tools.protectiveFactors?.date || '';
    flat['assess_protective_no'] = tools.protective?.no || tools.protectiveFactors?.no || false;
    flat['assess_protective_na'] = tools.protective?.na || tools.protectiveFactors?.na || false;

    flat['assess_dcfs'] = tools.dcfs?.used || tools.dcfsMultidisciplinary?.used || false;
    flat['assess_dcfs_yes'] = tools.dcfs?.yes || tools.dcfsMultidisciplinary?.yes || false;
    flat['assess_dcfs_date'] = tools.dcfs?.date || tools.dcfsMultidisciplinary?.date || '';
    flat['assess_dcfs_no'] = tools.dcfs?.no || tools.dcfsMultidisciplinary?.no || false;
    flat['assess_dcfs_na'] = tools.dcfs?.na || tools.dcfsMultidisciplinary?.na || false;

    flat['assess_ccs_patient'] = tools.ccsPatient?.used || tools.ccsPatientCare?.used || false;
    flat['assess_ccs_patient_yes'] = tools.ccsPatient?.yes || tools.ccsPatientCare?.yes || false;
    flat['assess_ccs_patient_date'] = tools.ccsPatient?.date || tools.ccsPatientCare?.date || '';
    flat['assess_ccs_patient_no'] = tools.ccsPatient?.no || tools.ccsPatientCare?.no || false;
    flat['assess_ccs_patient_na'] = tools.ccsPatient?.na || tools.ccsPatientCare?.na || false;

    flat['assess_dds'] = tools.dds?.used || tools.ddsRegionalCenter?.used || false;
    flat['assess_dds_yes'] = tools.dds?.yes || tools.ddsRegionalCenter?.yes || false;
    flat['assess_dds_date'] = tools.dds?.date || tools.ddsRegionalCenter?.date || '';
    flat['assess_dds_no'] = tools.dds?.no || tools.ddsRegionalCenter?.no || false;
    flat['assess_dds_na'] = tools.dds?.na || tools.ddsRegionalCenter?.na || false;

    flat['assess_cpsp'] = tools.cpsp?.used || tools.cpspAssessment?.used || false;
    flat['assess_cpsp_yes'] = tools.cpsp?.yes || tools.cpspAssessment?.yes || false;
    flat['assess_cpsp_date'] = tools.cpsp?.date || tools.cpspAssessment?.date || '';
    flat['assess_cpsp_no'] = tools.cpsp?.no || tools.cpspAssessment?.no || false;
    flat['assess_cpsp_na'] = tools.cpsp?.na || tools.cpspAssessment?.na || false;

    flat['assess_justice'] = tools.justice?.used || tools.justiceReentry?.used || false;
    flat['assess_justice_yes'] = tools.justice?.yes || tools.justiceReentry?.yes || false;
    flat['assess_justice_date'] = tools.justice?.date || tools.justiceReentry?.date || '';
    flat['assess_justice_no'] = tools.justice?.no || tools.justiceReentry?.no || false;
    flat['assess_justice_na'] = tools.justice?.na || tools.justiceReentry?.na || false;

    flat['assess_other'] = tools.other || false;
    flat['assess_other_list'] = tools.otherList || '';
    return flat;
};

const mapPhysicalHealth = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    const conditionsText = String(cyEcm.physicalHealth?.currentConditions || '').toLowerCase();
    const hasCond = (term: string) => conditionsText.includes(term);
    // --- Physical Health ---
    flat['vision_yes'] = cyEcm.physicalHealth?.vision?.yes || false;
    flat['vision_no'] = cyEcm.physicalHealth?.vision?.no || false;
    flat['vision_describe'] = cyEcm.physicalHealth?.vision?.describe || '';
    flat['glasses_yes'] = cyEcm.physicalHealth?.glasses?.yes || false;
    flat['glasses_no'] = cyEcm.physicalHealth?.glasses?.no || false;
    flat['glasses_need'] = cyEcm.physicalHealth?.glasses?.need || false;
    flat['tty_yes'] = cyEcm.physicalHealth?.tty?.yes || false;
    flat['tty_no'] = cyEcm.physicalHealth?.tty?.no || false;
    flat['tty_need'] = cyEcm.physicalHealth?.tty?.need || false;
    flat['diabetic_eye_yes'] = cyEcm.physicalHealth?.diabeticEye?.yes || false;
    flat['diabetic_eye_no'] = cyEcm.physicalHealth?.diabeticEye?.no || false;
    flat['diabetic_eye_na'] = cyEcm.physicalHealth?.diabeticEye?.na || false;

    flat['hearing_yes'] = cyEcm.physicalHealth?.hearing?.yes || false;
    flat['hearing_no'] = cyEcm.physicalHealth?.hearing?.no || false;
    flat['hearing_describe'] = cyEcm.physicalHealth?.hearing?.describe || '';
    flat['hearing_device_yes'] = cyEcm.physicalHealth?.hearingDevice?.yes || false;
    flat['hearing_device_no'] = cyEcm.physicalHealth?.hearingDevice?.no || false;
    flat['hearing_device_need'] = cyEcm.physicalHealth?.hearingDevice?.need || false;
    flat['hearing_device_list'] = cyEcm.physicalHealth?.hearingDevice?.list || '';
    flat['vision_other'] = cyEcm.physicalHealth?.visionOther || '';

    flat['health_rating_excellent'] = cyEcm.physicalHealth?.healthRating?.excellent || false;
    flat['health_rating_very_good'] = cyEcm.physicalHealth?.healthRating?.veryGood || false;
    flat['health_rating_good'] = cyEcm.physicalHealth?.healthRating?.good || false;
    flat['health_rating_fair'] = cyEcm.physicalHealth?.healthRating?.fair || false;
    flat['health_rating_poor'] = cyEcm.physicalHealth?.healthRating?.poor || false;
    flat['health_rating_declined'] = cyEcm.physicalHealth?.healthRating?.declined || false;
    // Template ID aliases
    flat['health_excellent'] = cyEcm.physicalHealth?.healthRating?.excellent || false;
    flat['health_very_good'] = cyEcm.physicalHealth?.healthRating?.veryGood || false;
    flat['health_good'] = cyEcm.physicalHealth?.healthRating?.good || false;
    flat['health_fair'] = cyEcm.physicalHealth?.healthRating?.fair || false;
    flat['health_poor'] = cyEcm.physicalHealth?.healthRating?.poor || false;
    flat['health_declined'] = cyEcm.physicalHealth?.healthRating?.declined || false;
    flat['health_rating_reason'] = cyEcm.physicalHealth?.healthRatingReason || '';

    flat['hospital_yes'] = cyEcm.physicalHealth?.hospital?.yes || false;
    flat['hospital_no'] = cyEcm.physicalHealth?.hospital?.no || false;
    flat['hospital_na'] = cyEcm.physicalHealth?.hospital?.na || false;
    flat['hospital_declined'] = cyEcm.physicalHealth?.hospital?.declined || false;
    flat['hospital_details'] = cyEcm.physicalHealth?.hospitalDetails || '';
    flat['medical_yes'] = cyEcm.physicalHealth?.newDiagnoses?.yes || false;
    flat['medical_no'] = cyEcm.physicalHealth?.newDiagnoses?.no || false;
    flat['cond_asthma'] = hasCond('asthma') || hasCond('lung');
    flat['cond_cancer'] = hasCond('cancer');
    flat['cond_cerebral'] = hasCond('cerebral palsy');
    flat['cond_cleft'] = hasCond('cleft');
    flat['cond_congenital'] = hasCond('congenital');
    flat['cond_cystic'] = hasCond('cystic');
    flat['cond_prediabetes'] = hasCond('prediabetes') || hasCond('pre-diabetes');
    flat['cond_diabetes1'] = hasCond('diabetes type 1') || hasCond('type 1');
    flat['cond_diabetes2'] = hasCond('diabetes type 2') || hasCond('type 2');
    flat['cond_hiv'] = hasCond('hiv') || hasCond('aids');
    flat['cond_hypertension'] = hasCond('hypertension') || hasCond('high blood pressure');
    flat['cond_kidney'] = hasCond('kidney');
    flat['cond_muscular'] = hasCond('muscular');
    flat['cond_physical'] = hasCond('physical disability') || hasCond('amputation') || hasCond('para') || hasCond('quadriplegic');
    flat['cond_seizures'] = hasCond('seizure') || hasCond('epilepsy');
    flat['cond_sickle'] = hasCond('sickle');
    flat['cond_spina'] = hasCond('spina');
    flat['cond_organ'] = hasCond('organ transplant') || hasCond('transplant');
    flat['cond_organ_list'] = cyEcm.physicalHealth?.newDiagnoses?.list || '';
    flat['cond_genetic'] = hasCond('genetic');
    flat['cond_genetic_list'] = cyEcm.physicalHealth?.newDiagnoses?.list || '';
    flat['cond_other'] = !!cyEcm.physicalHealth?.newDiagnoses?.list;
    flat['cond_other_list'] = cyEcm.physicalHealth?.newDiagnoses?.list || '';

    // --- Providers and medications ---
    flat['pcp_yes'] = cyEcm.physicalHealth?.pcpExists?.yes || false;
    flat['pcp_no'] = cyEcm.physicalHealth?.pcpExists?.no || false;
    flat['pcp_name'] = cyEcm.physicalHealth?.pcp?.name || '';
    flat['pcp_contact'] = cyEcm.physicalHealth?.pcp?.phone || '';
    flat['pcp_address'] = cyEcm.physicalHealth?.pcp?.address || '';
    flat['pcp_last_visit'] = cyEcm.physicalHealth?.pcp?.lastVisit || '';
    flat['pcp_last_visit_date'] = cyEcm.physicalHealth?.pcp?.lastVisit || '';
    flat['pcp_last_visit_purpose'] = cyEcm.physicalHealth?.pcpLastVisitPurpose || '';

    flat['dentist_yes'] = cyEcm.physicalHealth?.dentistExists?.yes || false;
    flat['dentist_no'] = cyEcm.physicalHealth?.dentistExists?.no || false;
    flat['dentist_name'] = cyEcm.physicalHealth?.dentist?.name || '';
    flat['dentist_contact'] = cyEcm.physicalHealth?.dentist?.phone || '';
    flat['dentist_address'] = cyEcm.physicalHealth?.dentist?.address || '';
    flat['dentist_last_visit_date'] = cyEcm.physicalHealth?.dentistLastVisitDate || '';
    flat['dentist_last_visit_purpose'] = cyEcm.physicalHealth?.dentistLastVisitPurpose || '';

    flat['dental_issues_yes'] = cyEcm.physicalHealth?.dentalIssues?.yes || false;
    flat['dental_issues_no'] = cyEcm.physicalHealth?.dentalIssues?.no || false;
    flat['dental_issues_na'] = cyEcm.physicalHealth?.dentalIssues?.na || false;
    flat['dental_issues_declined'] = cyEcm.physicalHealth?.dentalIssues?.declined || false;

    // Specialists
    flat['specialist_cardiology'] = cyEcm.physicalHealth?.specialistTypes?.cardiology || false;
    flat['specialist_developmental'] = cyEcm.physicalHealth?.specialistTypes?.developmental || false;
    flat['specialist_endocrinology'] = cyEcm.physicalHealth?.specialistTypes?.endocrinology || false;
    flat['specialist_genetics'] = cyEcm.physicalHealth?.specialistTypes?.genetics || false;
    flat['specialist_hematology'] = cyEcm.physicalHealth?.specialistTypes?.hematology || false;
    flat['specialist_immunology'] = cyEcm.physicalHealth?.specialistTypes?.immunology || false;
    flat['specialist_neurology'] = cyEcm.physicalHealth?.specialistTypes?.neurology || false;
    flat['specialist_oncology'] = cyEcm.physicalHealth?.specialistTypes?.oncology || false;
    flat['specialist_orthopedics'] = cyEcm.physicalHealth?.specialistTypes?.orthopedics || false;
    flat['specialist_pulmonology'] = cyEcm.physicalHealth?.specialistTypes?.pulmonology || false;
    flat['specialist_respite'] = cyEcm.physicalHealth?.specialistTypes?.respite || false;
    flat['specialist_physical_therapy'] = cyEcm.physicalHealth?.specialistTypes?.physicalTherapy || false;
    flat['specialist_occupational_therapy'] = cyEcm.physicalHealth?.specialistTypes?.occupationalTherapy || false;
    flat['specialist_speech_therapy'] = cyEcm.physicalHealth?.specialistTypes?.speechTherapy || false;
    flat['specialist_feeding_therapy'] = cyEcm.physicalHealth?.specialistTypes?.feedingTherapy || false;
    flat['specialist_other'] = cyEcm.physicalHealth?.specialistTypes?.other || false;
    flat['specialist_other_list'] = cyEcm.physicalHealth?.specialistTypes?.otherList || '';
    flat['specialist_contact_info'] = cyEcm.physicalHealth?.specialistsContactInfo || '';
    // Template ID aliases
    flat['spec_cardiology'] = cyEcm.physicalHealth?.specialistTypes?.cardiology || false;
    flat['spec_developmental'] = cyEcm.physicalHealth?.specialistTypes?.developmental || false;
    flat['spec_endocrinology'] = cyEcm.physicalHealth?.specialistTypes?.endocrinology || false;
    flat['spec_genetics'] = cyEcm.physicalHealth?.specialistTypes?.genetics || false;
    flat['spec_hematology'] = cyEcm.physicalHealth?.specialistTypes?.hematology || false;
    flat['spec_immunology'] = cyEcm.physicalHealth?.specialistTypes?.immunology || false;
    flat['spec_neurology'] = cyEcm.physicalHealth?.specialistTypes?.neurology || false;
    flat['spec_oncology'] = cyEcm.physicalHealth?.specialistTypes?.oncology || false;
    flat['spec_orthopedics'] = cyEcm.physicalHealth?.specialistTypes?.orthopedics || false;
    flat['spec_pulmonology'] = cyEcm.physicalHealth?.specialistTypes?.pulmonology || false;
    flat['spec_respite'] = cyEcm.physicalHealth?.specialistTypes?.respite || false;
    flat['spec_physical_therapy'] = cyEcm.physicalHealth?.specialistTypes?.physicalTherapy || false;
    flat['spec_occupational'] = cyEcm.physicalHealth?.specialistTypes?.occupationalTherapy || false;
    flat['spec_speech'] = cyEcm.physicalHealth?.specialistTypes?.speechTherapy || false;
    flat['spec_feeding'] = cyEcm.physicalHealth?.specialistTypes?.feedingTherapy || false;
    flat['spec_other'] = cyEcm.physicalHealth?.specialistTypes?.other || false;
    flat['spec_other_list'] = cyEcm.physicalHealth?.specialistTypes?.otherList || '';
    flat['spec_contact_info'] = cyEcm.physicalHealth?.specialistsContactInfo || '';

    // Medications
    flat['med1_name'] = cyEcm.physicalHealth?.medications?.[0]?.name || '';
    flat['med1_frequency'] = cyEcm.physicalHealth?.medications?.[0]?.frequency || '';
    flat['med1_route'] = cyEcm.physicalHealth?.medications?.[0]?.route || '';
    flat['med1_dosage'] = cyEcm.physicalHealth?.medications?.[0]?.dose || '';
    flat['med2_name'] = cyEcm.physicalHealth?.medications?.[1]?.name || '';
    flat['med2_frequency'] = cyEcm.physicalHealth?.medications?.[1]?.frequency || '';
    flat['med2_route'] = cyEcm.physicalHealth?.medications?.[1]?.route || '';
    flat['med2_dosage'] = cyEcm.physicalHealth?.medications?.[1]?.dose || '';
    flat['med3_name'] = cyEcm.physicalHealth?.medications?.[2]?.name || '';
    flat['med3_frequency'] = cyEcm.physicalHealth?.medications?.[2]?.frequency || '';
    flat['med3_route'] = cyEcm.physicalHealth?.medications?.[2]?.route || '';
    flat['med3_dosage'] = cyEcm.physicalHealth?.medications?.[2]?.dose || '';

    flat['med_difficulty_yes'] = cyEcm.physicalHealth?.medDifficulty?.yes || false;
    flat['med_difficulty_no'] = cyEcm.physicalHealth?.medDifficulty?.no || false;
    flat['med_difficulty_explain'] = cyEcm.physicalHealth?.medDifficultyExplain || '';
    flat['med_missed_yes'] = cyEcm.physicalHealth?.medMissed?.yes || false;
    flat['med_missed_no'] = cyEcm.physicalHealth?.medMissed?.no || false;
    flat['med_missed_explain'] = cyEcm.physicalHealth?.medMissedExplain || '';
    flat['med_adherence_yes'] = cyEcm.physicalHealth?.adherence?.yes || false;
    flat['med_adherence_no'] = cyEcm.physicalHealth?.adherence?.no || false;
    flat['med_adherence_sometimes'] = cyEcm.physicalHealth?.adherence?.sometimes || false;
    flat['med_adherence_declined'] = cyEcm.physicalHealth?.adherence?.declined || false;
    flat['med_adherence_explain'] = cyEcm.physicalHealth?.adherence?.explain || '';

    // Pain
    flat['pain_yes'] = cyEcm.physicalHealth?.pain?.yes || false;
    flat['pain_no'] = cyEcm.physicalHealth?.pain?.no || false;
    flat['pain_declined'] = cyEcm.physicalHealth?.pain?.declined || false;
    flat['pain_interference_not_at_all'] = cyEcm.physicalHealth?.painInterference?.notAtAll || false;
    flat['pain_interference_little_bit'] = cyEcm.physicalHealth?.painInterference?.littleBit || false;
    flat['pain_interference_moderately'] = cyEcm.physicalHealth?.painInterference?.moderately || false;
    flat['pain_interference_quite_a_bit'] = cyEcm.physicalHealth?.painInterference?.quiteABit || false;
    flat['pain_interference_extremely'] = cyEcm.physicalHealth?.painInterference?.extremely || false;
    flat['pain_interference_declined'] = cyEcm.physicalHealth?.painInterference?.declined || false;
    // Template ID aliases
    flat['pain_not_at_all'] = cyEcm.physicalHealth?.painInterference?.notAtAll || false;
    flat['pain_little_bit'] = cyEcm.physicalHealth?.painInterference?.littleBit || false;
    flat['pain_moderately'] = cyEcm.physicalHealth?.painInterference?.moderately || false;
    flat['pain_quite_a_bit'] = cyEcm.physicalHealth?.painInterference?.quiteABit || false;
    flat['pain_extremely'] = cyEcm.physicalHealth?.painInterference?.extremely || false;
    flat['pain_level_declined'] = cyEcm.physicalHealth?.painInterference?.declined || false;
    flat['pain_support_yes'] = cyEcm.physicalHealth?.painSupport?.yes || false;
    flat['pain_support_no'] = cyEcm.physicalHealth?.painSupport?.no || false;
    flat['pain_support_declined'] = cyEcm.physicalHealth?.painSupport?.declined || false;
    flat['pain_support_describe'] = cyEcm.physicalHealth?.painSupportDescribe || '';
    flat['pain_management_yes'] = cyEcm.physicalHealth?.painManagement?.yes || false;
    flat['pain_management_no'] = cyEcm.physicalHealth?.painManagement?.no || false;
    flat['pain_management_declined'] = cyEcm.physicalHealth?.painManagement?.declined || false;
    flat['pain_provider_name'] = cyEcm.physicalHealth?.painProvider?.name || '';
    flat['pain_provider_contact'] = cyEcm.physicalHealth?.painProvider?.phone || '';
    flat['pain_provider_address'] = cyEcm.physicalHealth?.painProvider?.address || '';
    flat['pain_provider_last_visit'] = cyEcm.physicalHealth?.painProvider?.lastVisit || '';
    return flat;
};

const mapMentalHealth = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // PHQ-9 and PHQ-2+Q9
    flat['phq9_score'] = cyEcm.mentalHealth?.phq9?.score || '';
    flat['phq9_date'] = cyEcm.mentalHealth?.phq9?.date || '';
    flat['phq9_na'] = cyEcm.mentalHealth?.phq9?.na || false;
    flat['phq9_declined'] = cyEcm.mentalHealth?.phq9?.declined || false;
    flat['phq9_declined_reason'] = cyEcm.mentalHealth?.phq9?.declinedReason || '';

    flat['phq_q1_0'] = cyEcm.mentalHealth?.phqQ1?.notAtAll || false;
    flat['phq_q1_1'] = cyEcm.mentalHealth?.phqQ1?.severalDays || false;
    flat['phq_q1_2'] = cyEcm.mentalHealth?.phqQ1?.moreHalf || false;
    flat['phq_q1_3'] = cyEcm.mentalHealth?.phqQ1?.nearlyEvery || false;
    flat['phq_q2_0'] = cyEcm.mentalHealth?.phqQ2?.notAtAll || false;
    flat['phq_q2_1'] = cyEcm.mentalHealth?.phqQ2?.severalDays || false;
    flat['phq_q2_2'] = cyEcm.mentalHealth?.phqQ2?.moreHalf || false;
    flat['phq_q2_3'] = cyEcm.mentalHealth?.phqQ2?.nearlyEvery || false;
    flat['phq_q9_0'] = cyEcm.mentalHealth?.phqQ9?.notAtAll || false;
    flat['phq_q9_1'] = cyEcm.mentalHealth?.phqQ9?.severalDays || false;
    flat['phq_q9_2'] = cyEcm.mentalHealth?.phqQ9?.moreHalf || false;
    flat['phq_q9_3'] = cyEcm.mentalHealth?.phqQ9?.nearlyEvery || false;
    flat['phq_actions'] = cyEcm.mentalHealth?.phqActions || '';

    // Mental Health - Additional
    flat['mh_diagnosis_yes'] = cyEcm.mentalHealth?.mhDiagnosis?.yes || false;
    flat['mh_diagnosis_no'] = cyEcm.mentalHealth?.mhDiagnosis?.no || false;
    flat['mh_diagnosis_declined'] = cyEcm.mentalHealth?.mhDiagnosis?.declined || false;
    flat['mh_diagnosis_na'] = cyEcm.mentalHealth?.mhDiagnosis?.na || false;

    flat['mh_diagnosis_depression'] = cyEcm.mentalHealth?.diagnosis?.depression || false;
    flat['mh_diagnosis_bipolar'] = cyEcm.mentalHealth?.diagnosis?.bipolar || false;
    flat['mh_diagnosis_psychotic'] = cyEcm.mentalHealth?.diagnosis?.psychotic || false;
    flat['mh_diagnosis_anxiety'] = cyEcm.mentalHealth?.diagnosis?.anxiety || false;
    flat['mh_diagnosis_eating'] = cyEcm.mentalHealth?.diagnosis?.eating || false;
    flat['mh_diagnosis_other'] = cyEcm.mentalHealth?.diagnosis?.other || false;
    flat['mh_diagnosis_other_list'] = cyEcm.mentalHealth?.diagnosis?.otherList || '';
    flat['mh_diagnosis_comments'] = cyEcm.mentalHealth?.diagnosisComments || '';

    flat['mh_provider_yes'] = cyEcm.mentalHealth?.mhProvider?.yes || false;
    flat['mh_provider_no'] = cyEcm.mentalHealth?.mhProvider?.no || false;
    flat['mh_provider_na'] = cyEcm.mentalHealth?.mhProvider?.na || false;
    flat['mh_provider_declined'] = cyEcm.mentalHealth?.mhProvider?.declined || false;
    flat['mh_provider_name'] = cyEcm.mentalHealth?.provider?.name || '';
    flat['mh_provider_contact'] = cyEcm.mentalHealth?.provider?.contact || '';
    flat['mh_provider_address'] = cyEcm.mentalHealth?.provider?.address || '';
    flat['mh_provider_last_visit'] = cyEcm.mentalHealth?.provider?.lastVisit || '';

    flat['social_less_once'] = cyEcm.mentalHealth?.social?.lessOnce || false;
    flat['social_one_two'] = cyEcm.mentalHealth?.social?.oneTwo || false;
    flat['social_three_five'] = cyEcm.mentalHealth?.social?.threeFive || false;
    flat['social_five_more'] = cyEcm.mentalHealth?.social?.fiveMore || false;
    flat['social_na'] = cyEcm.mentalHealth?.social?.na || false;
    flat['social_declined'] = cyEcm.mentalHealth?.social?.declined || false;

    flat['lonely_none'] = cyEcm.mentalHealth?.lonely?.none || false;
    flat['lonely_less_five'] = cyEcm.mentalHealth?.lonely?.lessFive || false;
    flat['lonely_more_half'] = cyEcm.mentalHealth?.lonely?.moreHalf || false;
    flat['lonely_most'] = cyEcm.mentalHealth?.lonely?.most || false;
    flat['lonely_na'] = cyEcm.mentalHealth?.lonely?.na || false;
    flat['lonely_declined'] = cyEcm.mentalHealth?.lonely?.declined || false;

    flat['parenting_yes'] = cyEcm.mentalHealth?.parenting?.yes || false;
    flat['parenting_no'] = cyEcm.mentalHealth?.parenting?.no || false;
    flat['parenting_declined'] = cyEcm.mentalHealth?.parenting?.declined || false;

    flat['behavior_yes'] = cyEcm.mentalHealth?.behaviorConcerns?.yes || false;
    flat['behavior_no'] = cyEcm.mentalHealth?.behaviorConcerns?.no || false;
    flat['behavior_na'] = cyEcm.mentalHealth?.behaviorConcerns?.na || false;
    flat['behavior_declined'] = cyEcm.mentalHealth?.behaviorConcerns?.declined || false;
    flat['behavior_describe'] = cyEcm.mentalHealth?.behaviorConcernsDescribe || '';

    flat['mh_support_requested'] = cyEcm.mentalHealth?.mhSupportRequested || '';

    flat['mh_safety_plan_yes'] = cyEcm.mentalHealth?.safetyPlan?.yes || false;
    flat['mh_safety_plan_no'] = cyEcm.mentalHealth?.safetyPlan?.no || false;
    flat['mh_safety_plan_na'] = cyEcm.mentalHealth?.safetyPlan?.na || false;

    flat['mh_suicidal_yes'] = cyEcm.mentalHealth?.suicidalIdeation?.yes || false;
    flat['mh_suicidal_no'] = cyEcm.mentalHealth?.suicidalIdeation?.no || false;
    flat['mh_suicidal_declined'] = cyEcm.mentalHealth?.suicidalIdeation?.declined || false;

    flat['mh_self_harm_yes'] = cyEcm.mentalHealth?.selfHarm?.yes || false;
    flat['mh_self_harm_no'] = cyEcm.mentalHealth?.selfHarm?.no || false;
    flat['mh_self_harm_declined'] = cyEcm.mentalHealth?.selfHarm?.declined || false;

    flat['mh_trauma_yes'] = cyEcm.mentalHealth?.traumaHistory?.yes || false;
    flat['mh_trauma_no'] = cyEcm.mentalHealth?.traumaHistory?.no || false;
    flat['mh_trauma_declined'] = cyEcm.mentalHealth?.traumaHistory?.declined || false;

    flat['mh_coping_strategies'] = cyEcm.mentalHealth?.copingStrategies || '';
    flat['mh_support_system'] = cyEcm.mentalHealth?.supportSystem || '';
    return flat;
};

const mapSubstanceUse = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // Substance Use
    flat['substance_use_yes'] = cyEcm.substanceUse?.currentUse?.yes || false;
    flat['substance_use_no'] = cyEcm.substanceUse?.currentUse?.no || false;
    flat['substance_use_declined'] = cyEcm.substanceUse?.currentUse?.declined || false;
    flat['substance_list'] = cyEcm.substanceUse?.substances?.map((s: { type: string }) => s.type).join(', ') || '';

    flat['treatment_history_yes'] = cyEcm.substanceUse?.treatmentHistory?.yes || false;
    flat['treatment_history_no'] = cyEcm.substanceUse?.treatmentHistory?.no || false;
    flat['treatment_history_na'] = cyEcm.substanceUse?.treatmentHistory?.na || false;
    flat['treatment_details'] = cyEcm.substanceUse?.treatmentDetails || '';

    flat['interest_treatment_yes'] = cyEcm.substanceUse?.interestInTreatment?.yes || false;
    flat['interest_treatment_no'] = cyEcm.substanceUse?.interestInTreatment?.no || false;
    flat['interest_treatment_na'] = cyEcm.substanceUse?.interestInTreatment?.na || false;

    flat['narcan_yes'] = cyEcm.substanceUse?.narcanAccess?.yes || false;
    flat['narcan_no'] = cyEcm.substanceUse?.narcanAccess?.no || false;
    flat['narcan_na'] = cyEcm.substanceUse?.narcanAccess?.na || false;

    flat['exposure_concerns_yes'] = cyEcm.substanceUse?.exposureConcerns?.yes || false;
    flat['exposure_concerns_no'] = cyEcm.substanceUse?.exposureConcerns?.no || false;
    flat['exposure_concerns_declined'] = cyEcm.substanceUse?.exposureConcerns?.declined || false;
    flat['exposure_concerns_describe'] = cyEcm.substanceUse?.exposureConcerns?.describe || '';
    return flat;
};

const mapOthers = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // Developmental / Cognitive
    flat['dev_delays_yes'] = cyEcm.developmentalCognitive?.developmentalDelays?.yes || false;
    flat['dev_delays_no'] = cyEcm.developmentalCognitive?.developmentalDelays?.no || false;
    flat['dev_delays_declined'] = cyEcm.developmentalCognitive?.developmentalDelays?.declined || false;
    flat['dev_delays_describe'] = cyEcm.developmentalCognitive?.developmentalDelays?.describe || '';

    flat['dev_iep_yes'] = cyEcm.developmentalCognitive?.iep504Plan?.yes || false;
    flat['dev_iep_no'] = cyEcm.developmentalCognitive?.iep504Plan?.no || false;
    flat['dev_iep_na'] = cyEcm.developmentalCognitive?.iep504Plan?.na || false;

    flat['dev_special_ed_yes'] = cyEcm.developmentalCognitive?.specialEducation?.yes || false;
    flat['dev_special_ed_no'] = cyEcm.developmentalCognitive?.specialEducation?.no || false;
    flat['dev_special_ed_na'] = cyEcm.developmentalCognitive?.specialEducation?.na || false;

    flat['dev_regional_center_yes'] = cyEcm.developmentalCognitive?.regionalCenterServices?.yes || false;
    flat['dev_regional_center_no'] = cyEcm.developmentalCognitive?.regionalCenterServices?.no || false;
    flat['dev_regional_center_na'] = cyEcm.developmentalCognitive?.regionalCenterServices?.na || false;

    flat['dev_ed_opportunities_yes'] = cyEcm.developmentalCognitive?.educationalOpportunities?.yes || false;
    flat['dev_ed_opportunities_no'] = cyEcm.developmentalCognitive?.educationalOpportunities?.no || false;
    flat['dev_ed_opportunities_na'] = cyEcm.developmentalCognitive?.educationalOpportunities?.na || false;
    flat['dev_ed_opportunities_describe'] = cyEcm.developmentalCognitive?.educationalOpportunities?.describe || '';

    flat['dev_cognitive_yes'] = cyEcm.developmentalCognitive?.cognitiveConcerns18Plus?.yes || false;
    flat['dev_cognitive_no'] = cyEcm.developmentalCognitive?.cognitiveConcerns18Plus?.no || false;
    flat['dev_cognitive_na'] = cyEcm.developmentalCognitive?.cognitiveConcerns18Plus?.na || false;
    flat['dev_cognitive_describe'] = cyEcm.developmentalCognitive?.cognitiveConcerns18Plus?.describe || '';

    // End of Life Planning
    flat['eol_applicable'] = cyEcm.endOfLifePlanning?.applicable || false;
    flat['eol_directive_yes'] = cyEcm.endOfLifePlanning?.advanceDirective?.yes || false;
    flat['eol_directive_no'] = cyEcm.endOfLifePlanning?.advanceDirective?.no || false;
    flat['eol_directive_declined'] = cyEcm.endOfLifePlanning?.advanceDirective?.declined || false;

    flat['eol_info_yes'] = cyEcm.endOfLifePlanning?.wantsInformation?.yes || false;
    flat['eol_info_no'] = cyEcm.endOfLifePlanning?.wantsInformation?.no || false;
    flat['eol_info_declined'] = cyEcm.endOfLifePlanning?.wantsInformation?.declined || false;

    // Pregnancy/Postpartum
    flat['preg_not_reviewed_child'] = cyEcm.pregnancyPostpartum?.notReviewedChild || false;
    flat['preg_not_reviewed_other'] = cyEcm.pregnancyPostpartum?.notReviewedOther || false;
    flat['preg_not_reviewed_reason'] = cyEcm.pregnancyPostpartum?.notReviewedReason || '';

    flat['pregnant_yes'] = cyEcm.pregnancyPostpartum?.currentlyPregnant?.yes || false;
    flat['pregnant_no'] = cyEcm.pregnancyPostpartum?.currentlyPregnant?.no || false;
    flat['pregnant_declined'] = cyEcm.pregnancyPostpartum?.currentlyPregnant?.declined || false;
    flat['pregnant_na'] = cyEcm.pregnancyPostpartum?.currentlyPregnant?.na || false;

    flat['pregnant_weeks'] = cyEcm.pregnancyPostpartum?.weeksPregnant || '';
    flat['discovered_pregnancy_yes'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.yes || false;
    flat['discovered_pregnancy_no'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.no || false;
    flat['discovered_pregnancy_na'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.na || false;
    flat['due_date'] = cyEcm.pregnancyPostpartum?.dueDate || '';
    // Template ID aliases
    flat['preg_disclosed_yes'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.yes || false;
    flat['preg_disclosed_no'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.no || false;
    flat['preg_disclosed_na'] = cyEcm.pregnancyPostpartum?.discoveredPregnancy?.na || false;
    flat['expected_delivery_date'] = cyEcm.pregnancyPostpartum?.dueDate || '';

    flat['ob_midwife_yes'] = cyEcm.pregnancyPostpartum?.obMidwife?.yes || false;
    flat['ob_midwife_no'] = cyEcm.pregnancyPostpartum?.obMidwife?.no || false;
    flat['ob_midwife_name'] = cyEcm.pregnancyPostpartum?.obMidwifeName || '';
    flat['ob_midwife_contact'] = cyEcm.pregnancyPostpartum?.obMidwifeContact || '';
    flat['ob_midwife_last_visit'] = cyEcm.pregnancyPostpartum?.obMidwifeLastVisit || '';

    flat['prenatal_provider_name'] = cyEcm.pregnancyPostpartum?.prenatalProvider?.name || '';
    flat['prenatal_provider_contact'] = cyEcm.pregnancyPostpartum?.prenatalProvider?.phone || '';
    flat['prenatal_provider_address'] = cyEcm.pregnancyPostpartum?.prenatalProvider?.address || '';
    flat['prenatal_provider_last_visit'] = cyEcm.pregnancyPostpartum?.prenatalProvider?.lastVisit || '';
    flat['first_prenatal_date'] = cyEcm.pregnancyPostpartum?.prenatalProvider?.lastVisit || '';

    flat['plan_delivery_yes'] = cyEcm.pregnancyPostpartum?.planDelivery?.yes || false;
    flat['plan_delivery_no'] = cyEcm.pregnancyPostpartum?.planDelivery?.no || false;
    flat['plan_delivery_na'] = cyEcm.pregnancyPostpartum?.planDelivery?.na || false;

    flat['plan_breastfeed_yes'] = cyEcm.pregnancyPostpartum?.planBreastfeed?.yes || false;
    flat['plan_breastfeed_no'] = cyEcm.pregnancyPostpartum?.planBreastfeed?.no || false;
    flat['plan_breastfeed_na'] = cyEcm.pregnancyPostpartum?.planBreastfeed?.na || false;

    flat['plan_doula_yes'] = cyEcm.pregnancyPostpartum?.planDoula?.yes || false;
    flat['plan_doula_no'] = cyEcm.pregnancyPostpartum?.planDoula?.no || false;

    flat['baby_crib'] = cyEcm.pregnancyPostpartum?.babyEssentials?.crib || false;
    flat['baby_car_seat'] = cyEcm.pregnancyPostpartum?.babyEssentials?.carSeat || false;
    flat['baby_diapers'] = cyEcm.pregnancyPostpartum?.babyEssentials?.diapers || false;
    flat['baby_formula'] = cyEcm.pregnancyPostpartum?.babyEssentials?.formula || false;
    flat['baby_breast_pump'] = cyEcm.pregnancyPostpartum?.babyEssentials?.breastPump || false;
    flat['baby_other'] = cyEcm.pregnancyPostpartum?.babyEssentials?.other || false;
    flat['baby_other_list'] = cyEcm.pregnancyPostpartum?.babyEssentials?.otherList || '';

    flat['birthing_classes_yes'] = cyEcm.pregnancyPostpartum?.birthingClasses?.yes || false;
    flat['birthing_classes_no'] = cyEcm.pregnancyPostpartum?.birthingClasses?.no || false;
    flat['birthing_classes_interested'] = cyEcm.pregnancyPostpartum?.birthingClasses?.interested || false;

    flat['postpartum_doula_yes'] = cyEcm.pregnancyPostpartum?.postpartumDoula?.yes || false;
    flat['postpartum_doula_no'] = cyEcm.pregnancyPostpartum?.postpartumDoula?.no || false;
    flat['postpartum_doula_interested'] = cyEcm.pregnancyPostpartum?.postpartumDoula?.interested || false;

    flat['lactation_consultant_yes'] = cyEcm.pregnancyPostpartum?.lactationConsultant?.yes || false;
    flat['lactation_consultant_no'] = cyEcm.pregnancyPostpartum?.lactationConsultant?.no || false;
    flat['lactation_consultant_interested'] = cyEcm.pregnancyPostpartum?.lactationConsultant?.interested || false;

    flat['postpartum_visit_yes'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.yes || false;
    flat['postpartum_visit_no'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.no || false;
    flat['postpartum_visit_na'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.na || false;
    flat['birth_yes'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.yes || false;
    flat['birth_no'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.no || false;
    flat['birth_na'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.na || false;
    flat['birth_declined'] = cyEcm.pregnancyPostpartum?.postpartumVisitCompleted?.declined || false;
    flat['postpartum_visit_date'] = cyEcm.pregnancyPostpartum?.postpartumVisitDate || '';

    flat['baby_pediatrician_name'] = cyEcm.pregnancyPostpartum?.babyPediatrician?.name || '';
    flat['baby_pediatrician_contact'] = cyEcm.pregnancyPostpartum?.babyPediatrician?.phone || '';
    flat['baby_pediatrician_last_visit'] = cyEcm.pregnancyPostpartum?.babyPediatrician?.lastVisit || '';
    return flat;
};

const mapADLAndSDoH = (cyEcm: any) => {
    const flat: Record<string, unknown> = {};
    // ADLs
    // Infant/Toddler
    flat['infant_feeding_independent'] = cyEcm.adls?.infantToddler?.feedingSucking?.independent || false;
    flat['infant_feeding_support'] = cyEcm.adls?.infantToddler?.feedingSucking?.needsSupport || false;
    flat['infant_feeding_na'] = cyEcm.adls?.infantToddler?.feedingSucking?.na || false;
    flat['infant_sleeping_independent'] = cyEcm.adls?.infantToddler?.sleeping?.independent || false;
    flat['infant_sleeping_support'] = cyEcm.adls?.infantToddler?.sleeping?.needsSupport || false;
    flat['infant_sleeping_na'] = cyEcm.adls?.infantToddler?.sleeping?.na || false;
    flat['infant_motor_independent'] = cyEcm.adls?.infantToddler?.motorDevelopment?.independent || false;
    flat['infant_motor_support'] = cyEcm.adls?.infantToddler?.motorDevelopment?.needsSupport || false;
    flat['infant_motor_na'] = cyEcm.adls?.infantToddler?.motorDevelopment?.na || false;

    // Preschool
    flat['preschool_dressing_independent'] = cyEcm.adls?.preschool?.dressing?.independent || false;
    flat['preschool_dressing_support'] = cyEcm.adls?.preschool?.dressing?.needsSupport || false;
    flat['preschool_dressing_na'] = cyEcm.adls?.preschool?.dressing?.na || false;
    flat['preschool_toileting_independent'] = cyEcm.adls?.preschool?.toileting?.independent || false;
    flat['preschool_toileting_support'] = cyEcm.adls?.preschool?.toileting?.needsSupport || false;
    flat['preschool_toileting_na'] = cyEcm.adls?.preschool?.toileting?.na || false;
    flat['preschool_feeding_independent'] = cyEcm.adls?.preschool?.feeding?.independent || false;
    flat['preschool_feeding_support'] = cyEcm.adls?.preschool?.feeding?.needsSupport || false;
    flat['preschool_feeding_na'] = cyEcm.adls?.preschool?.feeding?.na || false;
    flat['preschool_social_independent'] = cyEcm.adls?.preschool?.socialPlay?.independent || false;
    flat['preschool_social_support'] = cyEcm.adls?.preschool?.socialPlay?.needsSupport || false;
    flat['preschool_social_na'] = cyEcm.adls?.preschool?.socialPlay?.na || false;

    // School Age
    flat['school_hygiene_independent'] = cyEcm.adls?.schoolAge?.hygiene?.independent || false;
    flat['school_hygiene_support'] = cyEcm.adls?.schoolAge?.hygiene?.needsSupport || false;
    flat['school_hygiene_na'] = cyEcm.adls?.schoolAge?.hygiene?.na || false;
    flat['school_homework_independent'] = cyEcm.adls?.schoolAge?.homework?.independent || false;
    flat['school_homework_support'] = cyEcm.adls?.schoolAge?.homework?.needsSupport || false;
    flat['school_homework_na'] = cyEcm.adls?.schoolAge?.homework?.na || false;
    flat['school_peer_independent'] = cyEcm.adls?.schoolAge?.peerInteraction?.independent || false;
    flat['school_peer_support'] = cyEcm.adls?.schoolAge?.peerInteraction?.needsSupport || false;
    flat['school_peer_na'] = cyEcm.adls?.schoolAge?.peerInteraction?.na || false;
    flat['school_chores_independent'] = cyEcm.adls?.schoolAge?.chores?.independent || false;
    flat['school_chores_support'] = cyEcm.adls?.schoolAge?.chores?.needsSupport || false;
    flat['school_chores_na'] = cyEcm.adls?.schoolAge?.chores?.na || false;

    // Adolescent
    flat['adolescent_personal_independent'] = cyEcm.adls?.adolescent?.personalCare?.independent || false;
    flat['adolescent_personal_support'] = cyEcm.adls?.adolescent?.personalCare?.needsSupport || false;
    flat['adolescent_personal_na'] = cyEcm.adls?.adolescent?.personalCare?.na || false;
    flat['adolescent_time_independent'] = cyEcm.adls?.adolescent?.timeManagement?.independent || false;
    flat['adolescent_time_support'] = cyEcm.adls?.adolescent?.timeManagement?.needsSupport || false;
    flat['adolescent_time_na'] = cyEcm.adls?.adolescent?.timeManagement?.na || false;
    flat['adolescent_health_independent'] = cyEcm.adls?.adolescent?.healthManagement?.independent || false;
    flat['adolescent_health_support'] = cyEcm.adls?.adolescent?.healthManagement?.needsSupport || false;
    flat['adolescent_health_na'] = cyEcm.adls?.adolescent?.healthManagement?.na || false;
    flat['adolescent_transport_independent'] = cyEcm.adls?.adolescent?.transportation?.independent || false;
    flat['adolescent_transport_support'] = cyEcm.adls?.adolescent?.transportation?.needsSupport || false;
    flat['adolescent_transport_na'] = cyEcm.adls?.adolescent?.transportation?.na || false;

    // Transition
    flat['transition_cooking_independent'] = cyEcm.adls?.adultTransition?.cooking?.independent || false;
    flat['transition_cooking_support'] = cyEcm.adls?.adultTransition?.cooking?.needsSupport || false;
    flat['transition_cooking_na'] = cyEcm.adls?.adultTransition?.cooking?.na || false;
    flat['transition_finance_independent'] = cyEcm.adls?.adultTransition?.financialManagement?.independent || false;
    flat['transition_finance_support'] = cyEcm.adls?.adultTransition?.financialManagement?.needsSupport || false;
    flat['transition_finance_na'] = cyEcm.adls?.adultTransition?.financialManagement?.na || false;
    flat['transition_employ_independent'] = cyEcm.adls?.adultTransition?.employment?.independent || false;
    flat['transition_employ_support'] = cyEcm.adls?.adultTransition?.employment?.needsSupport || false;
    flat['transition_employ_na'] = cyEcm.adls?.adultTransition?.employment?.na || false;
    flat['transition_living_independent'] = cyEcm.adls?.adultTransition?.independentLiving?.independent || false;
    flat['transition_living_support'] = cyEcm.adls?.adultTransition?.independentLiving?.needsSupport || false;
    flat['transition_living_na'] = cyEcm.adls?.adultTransition?.independentLiving?.na || false;

    flat['adl_help_yes'] = cyEcm.adls?.supportNeeded?.yes || false;
    flat['adl_help_no'] = cyEcm.adls?.supportNeeded?.no || false;
    flat['adl_help_declined'] = cyEcm.adls?.supportNeeded?.declined || false;
    flat['adl_help_comments'] = cyEcm.adls?.supportNeeded?.explain || '';

    flat['adl_equipment_yes'] = cyEcm.adls?.medicalEquipment?.yes || false;
    flat['adl_equipment_no'] = cyEcm.adls?.medicalEquipment?.no || false;
    flat['adl_equipment_declined'] = cyEcm.adls?.medicalEquipment?.declined || false;
    flat['adl_equipment_list'] = cyEcm.adls?.medicalEquipment?.list || '';

    // SDoH - Housing
    flat['housing_house'] = cyEcm.sdoh?.housing?.currentSituation === 'house' || false;
    flat['housing_apartment'] = cyEcm.sdoh?.housing?.currentSituation === 'apartment' || false;
    flat['housing_shelter'] = cyEcm.sdoh?.housing?.currentSituation === 'shelter' || false;
    flat['housing_shared'] = cyEcm.sdoh?.housing?.currentSituation === 'shared' || false;
    flat['housing_homeless'] = cyEcm.populationOfFocus?.homeless || false;
    flat['lose_housing_yes'] = cyEcm.sdoh?.housing?.stable?.no || false;
    flat['lose_housing_no'] = cyEcm.sdoh?.housing?.stable?.yes || false;
    flat['lose_housing_explain'] = cyEcm.sdoh?.housing?.concerns || '';

    // Home environment checklist
    flat['home_lighting_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.adequateLighting || false;
    flat['home_heating_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.adequateHeating || false;
    flat['home_cooling_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.adequateCooling || false;
    flat['home_rails_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.safetyRails || false;
    flat['home_hotwater_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.hotWater || false;
    flat['home_toilet_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.workingToilet || false;
    flat['home_locks_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.workingLocks || false;
    flat['home_stairs_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.safeStairs || false;
    flat['home_elevator_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.elevatorAccess || false;
    flat['home_wheelchair_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.wheelchairAccessible || false;
    flat['home_exit_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.emergencyExits || false;
    flat['home_leadpaint_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.leadPaintConcerns || false;
    flat['home_mold_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.moldMildew || false;
    flat['home_overcrowding_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.overcrowding || false;
    flat['home_utilities_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.utilitiesPaid || false;
    flat['home_pests_yes'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.pestInfestation || false;
    flat['home_additional_explain'] = cyEcm.sdoh?.environmentalSafety?.homeSafetyChecklist?.additionalConcerns || '';

    // Benefits & services
    flat['benefit_calfresh'] = cyEcm.benefitsServices?.currentBenefits?.calFresh || false;
    flat['benefit_tanf'] = cyEcm.benefitsServices?.currentBenefits?.tanf || false;
    flat['benefit_school_meals'] = cyEcm.benefitsServices?.currentBenefits?.other || false;
    flat['benefit_wic'] = cyEcm.benefitsServices?.currentBenefits?.wic || false;
    flat['benefit_wic_site'] = cyEcm.benefitsServices?.currentBenefits?.other || '';
    flat['benefit_needs'] = cyEcm.benefitsServices?.benefitNeeds || '';

    // Legal involvement
    flat['legal_court'] = cyEcm.legalInvolvement?.past12Months?.courtOrderedServices || false;
    flat['legal_probation'] = cyEcm.legalInvolvement?.past12Months?.probation || false;
    flat['legal_parole'] = cyEcm.legalInvolvement?.past12Months?.parole || false;
    flat['legal_reentry'] = cyEcm.legalInvolvement?.past12Months?.reentryProgram || false;
    flat['legal_cps'] = cyEcm.legalInvolvement?.past12Months?.cps || false;
    flat['legal_comments'] = cyEcm.legalInvolvement?.comments || '';
    flat['reentry_provider'] = cyEcm.legalInvolvement?.reentryProvider?.yes || false;
    flat['legal_provider_name'] = cyEcm.legalInvolvement?.providerInfo?.name || '';
    flat['legal_provider_contact'] = cyEcm.legalInvolvement?.providerInfo?.phone || '';
    flat['legal_provider_address'] = cyEcm.legalInvolvement?.providerInfo?.address || '';

    // Narrative and next steps
    flat['narrative_summary'] = cyEcm.narrativeSummary?.primaryNeeds || '';
    flat['next_step_1'] = cyEcm.narrativeSummary?.nextSteps?.[0]?.step || '';
    flat['next_step_1_person'] = cyEcm.narrativeSummary?.nextSteps?.[0]?.personResponsible || '';
    flat['next_step_2'] = cyEcm.narrativeSummary?.nextSteps?.[1]?.step || '';
    flat['next_step_2_person'] = cyEcm.narrativeSummary?.nextSteps?.[1]?.personResponsible || '';
    flat['next_step_3'] = cyEcm.narrativeSummary?.nextSteps?.[2]?.step || '';
    flat['next_step_3_person'] = cyEcm.narrativeSummary?.nextSteps?.[2]?.personResponsible || '';
    flat['next_appointment_location'] = cyEcm.narrativeSummary?.nextAppointmentLocation || '';
    return flat;
};

export const mapCyEcmAssessmentToFlat = (cyEcm: any) => {
    if (!cyEcm) return {};
    return {
        ...mapPopulationPrograms(cyEcm),
        ...mapConsentDemographics(cyEcm),
        ...mapAssessments(cyEcm),
        ...mapPhysicalHealth(cyEcm),
        ...mapMentalHealth(cyEcm),
        ...mapSubstanceUse(cyEcm),
        ...mapOthers(cyEcm), // Dev/EOL/Pregnancy
        ...mapADLAndSDoH(cyEcm),
    };
};
